export default __webpack_public_path__ + "static/media/img1.0fccf2eb.jpg";